// (Routes that do NOT require a token or authentication)
import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../shared/components/Login";
import Callback from "../shared/components/Callback";
import TopologyView from "../ctxReflectorV2/views/TopologyView";
import { AUTH_REDIRECT_PATH } from "../shared/config/authRedirect";

export function PublicRoutes() {
    return (
        <Routes>
            {/* LOGIN is public */}
            <Route path="/login" element={<Login />} />

            {/* Auth callback (path from REACT_APP_REDIRECT_PATH, default /redirecting) */}
            <Route path={AUTH_REDIRECT_PATH} element={<Callback />} />

            {/* Public topology export route (no auth) */}
            <Route path="/reflector-v2/management/topology-export/*" element={<TopologyView />} />

            {/* Add any other public routes you need here */}
        </Routes>
    );
}
